import { createContext, useContext } from 'react';
export const ListItemContext = createContext(null);
export const useListItemContext = () => {
    const context = useContext(ListItemContext);
    if (!context) {
        throw new Error('There is no context provided.');
    }
    return context;
};
